import { HTMLAudioElementWithSetSinkId, usePhoneStore } from '@hit/react-jssip';
import { PropsWithChildren, useEffect, useRef } from 'react';

import useActiveCall from '@/hooks/use-active-call';

const ActiveCallAudio = ({ children }: PropsWithChildren) => {
  const call = useActiveCall();

  const audioTrack = call?.incomingAudioTrack;
  const sinkId = usePhoneStore((state) => state.outputDeviceId);

  const audioRef = useRef<HTMLAudioElementWithSetSinkId>(null);
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio || !audioTrack) return;
    audio.srcObject = new MediaStream([audioTrack]);

    return () => {
      audio.srcObject = null;
    };
  }, [audioTrack]);
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio || !sinkId || !audio?.setSinkId) return;

    audio.setSinkId(sinkId);

    return () => {
      audio.setSinkId('default');
    };
  }, [sinkId]);

  return (
    <>
      <audio hidden autoPlay ref={audioRef} />
      {children}
    </>
  );
};

export default ActiveCallAudio;
